import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Nav, CustomCursor, MobileStickyCTA, PortalIntro } from "./components/Chrome";
import { Hero, Ticker, Manifesto, Letter, Audience, Roadmap } from "./components/SectionsA";
import { Curriculum, Host, Transformation, Takeaways, Faq, FinalRegistration, Footer } from "./components/SectionsB";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import Replay from "./pages/Replay";
import ThankYou from "./pages/ThankYou";

gsap.registerPlugin(ScrollTrigger);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Landing = () => {
  return (
  <>
    <PortalIntro />
    <Nav />
    <main className="relative z-10">
      <Hero />
      <Ticker />
      <Manifesto />
      <Letter />
      <Audience />
      <Roadmap />
      <Curriculum />
      <Host />
      <Transformation />
      <Takeaways />
      <Faq />
      <FinalRegistration />
      <Footer />
    </main>
    <MobileStickyCTA />
  </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-[#070B11] text-[#EDF2F7]">
      <div className="grid-lines" />
      <div className="grain-overlay" />
      <CustomCursor />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/replay" element={<Replay />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy-terms" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
